import React from 'react'
import { Box, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

function Support() {
  return (
    <Box sx={{ height: '100%', display: 'flex', gap: { xs: 1, md: 3 }, flexDirection: 'column', justifyContent: 'start', alignItems: 'start' }} >
      <Typography variant='h5' sx={{ ml: 2, mt: 2 }} >
        Support
      </Typography>
      <Box sx={{ ml: 3, display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'start' }} >
        <Link to="/faq_s" style={{ textDecoration: 'none' }} ><Typography style={{ fontSize: '0.9rem', color: 'white' }} >Help & FAQ's</Typography></Link>
        <Link to="/contact" style={{ textDecoration: 'none' }} ><Typography sx={{ fontSize: '0.9rem', color: 'white' }} >Contact Us</Typography></Link>
        <Link to="/about" style={{ textDecoration: 'none' }} ><Typography sx={{ fontSize: '0.9rem', color: 'white' }} >About Us</Typography></Link>
      </Box>
    </Box>
  )
}

export default Support
